import React, { useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import Header from './components/Header';
import Router from './components/Router';
import LogCannon from '@ace-clublabs/log-cannon';
import './styles/main.scss';
import { autoPayPath, basePath } from './shared/constants';
import { setGlobalState, useGlobalState } from './shared/state';
import { getQueryProps } from './utils/useQueryParamsHooks';
import { TeamValue, WorkloadValue } from '@ace-clublabs/aws-tags';
import { ThemeProvider, Box } from '@ace-clublabs/shared-component-library';

const setIsMobileApp = (isMobileApp: boolean): void => setGlobalState('isMobileApp', isMobileApp);
const setQueryProps = (queryProps: any) => setGlobalState('queryProps', queryProps);

interface WrapperProps {
  children?: React.ReactNode;
}
interface HeaderWrapperProps {
  isMobileApp: boolean;
}

const HeaderWrapper: React.FC<HeaderWrapperProps> = ({ isMobileApp }) => (
  <>{isMobileApp ? <Box className="mobile-header-spacer" /> : <Header />}</>
);
const MainWrapper: React.FC<WrapperProps> = ({ children }) => (
  <main>
    <Box className="appContainer">{children}</Box>
  </main>
);
const FooterWrapper: React.FC = () => <footer />;

export const App = () => {
  const [queryProps, setLocalQueryProps] = useState({});
  const [isMobileApp] = useGlobalState('isMobileApp');
  const paramsFromUrl: any = getQueryProps();
  const path = window.location.pathname;

  let base_url;
  let appName;
  if (path.startsWith(autoPayPath)) {
    base_url = autoPayPath;
    appName = 'insurance-apwol';
    document.title = 'AAA | Enroll in Auto Pay';
  } else {
    base_url = basePath; // change to '/' to run in local
    appName = 'insurance-pwol';
    document.title = 'AAA | Make a payment';
  }

  const apiKey = import.meta.env.VITE_LOGCANNON_API_KEY;

  LogCannon.init(apiKey, {
    team: TeamValue.Payments,
    component: appName,
    workload: WorkloadValue.Payments,
    runtime: 'nodejs',
    runtimeVersion: process.version,
  } as any);

  useEffect(() => {
    const updatedProps: any = { ...queryProps };
    Object.entries(paramsFromUrl).forEach(([key, value]) => {
      updatedProps[key as any] = value;
    });
    setLocalQueryProps(updatedProps);
    setQueryProps(updatedProps);

    if (updatedProps.mobileapp === 'true') {
      setIsMobileApp(true);
    }
  }, []);

  return (
    <BrowserRouter basename={base_url}>
      <ThemeProvider>
        <HeaderWrapper isMobileApp={isMobileApp} />
        <MainWrapper>
          <Router />
        </MainWrapper>
        <FooterWrapper />
      </ThemeProvider>
    </BrowserRouter>
  );
};

export default App;
